import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Typography,
    TextField
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Deadlineorder = ({ deleteDialog, setdeleteDialog, setgetOrder, selectedOrder, mode, selectedsubOrder, setgetSubOrder }) => {
    //handle close
    const handleClose = () => {
        setdeleteDialog(false);
        // Optionally, clear the date field when the dialog is closed
        setOrderDeadline(null)
        setsubOrderDeadline(null)

    };


    // Handle set deadline time  API call
    const formatdate = dayjs()
    const [orderdeadline, setOrderDeadline] = useState();
    const [suboderdeadline, setsubOrderDeadline] = useState();

    //deadline order
    const handleDeadlinetime = async (selectedOrder) => {
        if (!orderdeadline) {
            toast.error('Please select a valid deadline.');
            return;
        }
        try {
            const response = await instance.patch('/Order/setDeadline',
                {
                    order_id: selectedOrder._id, // Use `selectedOrder` to access `order_id`
                    deadline:orderdeadline
                }
            )

            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setgetOrder(true)
                setOrderDeadline(formatdate);
            } else {
                toast.error(response.data.message)
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        }
    }


    // Handle set deadline time  API call suborder
    const handleDeadlinetimesuborder = async (selectedsubOrder) => {
        if (!suboderdeadline) {
            toast.error('Please select a valid deadline.');
            return;
        }
        try {
            const response = await instance.patch('/Order/setSubOrderDeadline',
                {
                    order_id: selectedsubOrder?._id, // Use `selectedOrder` to access `order_id`
                    deadline: suboderdeadline
                }
            )

            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setgetSubOrder(true);
                setsubOrderDeadline(formatdate);
            } else {
                toast.error(response.data.message)
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        }
    }

    // // When the selectedOrder changes, update the deadline
    useEffect(() => {
        if (selectedOrder?.deadline) {
            setOrderDeadline(dayjs(selectedOrder?.deadline));
        }
    }, [selectedOrder]);

    // When the selectedsubOrder changes, update the deadline
    useEffect(() => {
        if (selectedsubOrder?.deadline) {
            setsubOrderDeadline(dayjs(selectedsubOrder?.deadline));
        }
    }, [selectedsubOrder]);

    return (
        <>
            {mode === "orders" ?
                (
                    <React.Fragment>
                        <BootstrapDialog
                            onClose={handleClose}
                            aria-labelledby="customized-dialog-title"
                            open={deleteDialog}
                            className="admin-admins"
                        >
                            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                                Set Order Deadline
                                <Typography variant="subtitle1" >
                                    Select a deadline for the orders
                                </Typography>
                            </DialogTitle>
                            <hr style={{ margin: "5px 0px" }} />
                            <IconButton
                                aria-label="close"
                                onClick={handleClose}
                                sx={{
                                    position: "absolute",
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                            <DialogContent dividers>
                                <section className="add-admin">
                                    <Grid container spacing={2}>
                                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                            <div className='employee-checkin-date'>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        label="Select Deadline"
                                                        value={orderdeadline}
                                                        onChange={(newValue) => {
                                                            // Set the selected date to the state
                                                            setOrderDeadline(newValue);
                                                        }}
                                                        format="DD/MM/YYYY"
                                                        minDate={dayjs()} // Disable previous dates
                                                        renderInput={(props) => (
                                                            <div>
                                                                <input {...props} placeholder="Select Deadline" />
                                                            </div>
                                                        )}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </section>
                                {/* <hr style={{ margin: "15px 0px" }} />
                <section className="add-order">
                    <div className='add-employee-title'>
                        <Typography>Previous Bookings</Typography>
                    </div>
                    <CommonTable columns={data.columns} rows={data.rows} />
                </section> */}
                            </DialogContent>
                            <DialogActions>
                                <Button className="cancel-btn" onClick={handleClose}>
                                    Cancel
                                </Button>
                                <Button className="add-btn" onClick={() => handleDeadlinetime(selectedOrder)}>Set order Deadline</Button>
                            </DialogActions>
                        </BootstrapDialog>
                    </React.Fragment>
                ) :
                (
                    <React.Fragment>
                        <BootstrapDialog
                            onClose={handleClose}
                            aria-labelledby="customized-dialog-title"
                            open={deleteDialog}
                            className="admin-admins"
                        >
                            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                                Set subOrder deadline
                                <Typography variant="subtitle1">
                                    Select a deadline for the subOrder
                                </Typography>
                            </DialogTitle>
                            <hr style={{ margin: "5px 0px" }} />
                            <IconButton
                                aria-label="close"
                                onClick={handleClose}
                                sx={{
                                    position: "absolute",
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                            <DialogContent dividers>
                                <section className="add-admin">
                                    <Grid container spacing={2}>
                                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                            <div className='employee-checkin-date'>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        label="Select Deadline"
                                                        value={suboderdeadline}
                                                        onChange={(newValue) => {
                                                            // Set the selected date to the state
                                                            setsubOrderDeadline(newValue);
                                                        }}
                                                        format="DD/MM/YYYY"
                                                        minDate={dayjs()} // Disable previous dates
                                                        renderInput={(props) => (
                                                            <div>
                                                                <input {...props} placeholder="Select Deadline" />
                                                            </div>
                                                        )}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </section>
                                {/* <hr style={{ margin: "15px 0px" }} />
                <section className="add-order">
                    <div className='add-employee-title'>
                        <Typography>Previous Bookings</Typography>
                    </div>
                    <CommonTable columns={data.columns} rows={data.rows} />
                </section> */}
                            </DialogContent>
                            <DialogActions>
                                <Button className="cancel-btn" onClick={handleClose}>
                                    Cancel
                                </Button>
                                <Button className="add-btn" onClick={() => handleDeadlinetimesuborder(selectedsubOrder)}>Set suborder Deadline</Button>
                            </DialogActions>
                        </BootstrapDialog>
                    </React.Fragment>
                )
            }


        </>
    )
}

export default Deadlineorder;